<template>
  <header class="mobile-top-bar">
    <img
      class="mobile-top-bar__brand"
      src="/images/logo-dark.svg"
      alt="AudioScribe"
    />
    <h1 class="mobile-top-bar__title">{{ title }}</h1>
    <div class="mobile-top-bar__actions">
      <slot name="actions"></slot>
    </div>
  </header>
</template>

<script>
export default {
  name: "MobileTopBar",
  props: {
    title: {
      type: String,
      default: "",
    },
  },
};
</script>
